import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HeaderService } from '../../services/header.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss'
})
export class NotificationComponent {
  notificationsDetails: any;
  totalNotificationCount: number = 0;
  notificationList: Array<any> = []

  selectedNotification: any;
  pageNumber: number = 1;
  isMobile: boolean;
  showLeftPanel: boolean = true;
  showRightPanel: boolean = true;

  subscription: Array<Subscription> = [];

  constructor(
    private router: Router,
    private headerService: HeaderService
  ) {
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(navigator.userAgent)
    console.log(this.isMobile);
  }

  ngOnInit() {
    if (!this.isMobile) {
      this.headerService.updateHeaderDetails({ displayOnlyLogo: true });
    }
    else {
      this.showRightPanel = false;
    }
    this.getNotifications(this.pageNumber);
    this.subscription.push(this.headerService.selectedNotification.subscribe((res: any) => {
      if (res) {
        this.selectedNotification = res;
      }
    }))
  }

  getNotifications(pageNumber: number) {
    let body = {
      "pageSize": 10,
      "pageNumber": pageNumber
    }
    this.headerService.getNotifications(body).subscribe((res: any) => {
      this.headerService.updateNotificationLoaded(true);
      if (res && res.status && res.status.isSuccess) {
        this.notificationsDetails = res.content;
        if (this.notificationsDetails.totalNotifications) {
          this.totalNotificationCount = this.notificationsDetails.totalNotifications;
          if (!this.notificationList.length) {
            this.notificationList = this.notificationsDetails.notificationsList;
          }
          else {
            this.notificationsDetails.notificationsList.forEach((ele: any) => {
              let notifications = this.notificationList.find(noti => noti.dateTime == ele.dateTime);
              if (notifications) {
                let newNotification = notifications.notifications.concat(ele.notifications);
                notifications.notifications = newNotification;
              }
              else {
                this.notificationList.push(ele);
              }
            })
          }
          // if (!this.selectedNotification && !this.isMobile) {
          //   this.selectedNotification = this.notificationList[0].notifications[0];
          //   this.notificationList[0].notifications[0].isRead = true;
          //   this.getNotificationDetailsById(this.selectedNotification.id);
          // }

          if(this.selectedNotification){
            this.notificationList.forEach(ele => {
              ele.notifications.forEach((element:any) => {
                  if(element.id == this.selectedNotification.id){
                    element.isRead = true;
                  }
              });
            })
            this.getNotificationDetailsById(this.selectedNotification.id);
          }
        }
      }
    })
  }

  getNotificationDetailsById(id: number) {
    let body = {
      "notificationId": id
    }
    this.headerService.getNotificationById(body).subscribe((res: any) => {
      if (res && res.status && res.status.isSuccess) {
        this.selectedNotification = res.content;
      }
    })
  }

  backClick() {
    if (!this.isMobile) {
      this.headerService.updateNotificationLoaded(false);
      this.router.navigate(['/home/account']);
      this.headerService.updateNotification(true);
    }
    else {
      this.showLeftPanel = true;
      this.showRightPanel = false;
    }
  }

  notificationClick(index1: number, index2: number) {
    this.selectedNotification = this.notificationList[index1].notifications[index2]
    this.getNotificationDetailsById(this.selectedNotification.id);
    this.notificationList[index1].notifications[index2].isRead = true;
    if (this.isMobile) {
      this.showLeftPanel = false;
      this.showRightPanel = true;
    }
  }

  formatDate(date: Date) {
    if (new Date(date).toDateString() == new Date().toDateString()) {
      return 'Today';
    }
    else if (new Date(date).toDateString() == new Date(new Date().setDate(new Date().getDate() - 1)).toDateString()) {
      return 'Yesterday'
    }
    else
      return new DatePipe('en-US').transform(date, 'dd MMMM yyyy');
  }

  listScroll(event: any) {
    let obj = document.getElementsByClassName('list-container')[0];
    if ((obj.scrollHeight - (obj.scrollTop + obj.clientHeight)) <= 3) {
      let totalCount = 0;
      this.notificationList.forEach(ele => {
        totalCount += ele.notifications.length;
      })
      if (totalCount < this.totalNotificationCount) {
        this.pageNumber++;
        this.getNotifications(this.pageNumber);
      }
    }
  }

  onLinkClick() {
    window.open(this.selectedNotification?.link, 'Blank');
  }
}
